import React, { useState } from "react";
import BuyPlan from "./PlanPurchase/BuyPlan";

const MagmaPremiumCarePlan = () => {
  const [openPopup, setOpenPopup] = useState(false);
  const [planCode, setPlanCode] = useState("");
  const [tenantId, setTenantId] = useState("T2047001XT8");
  const [isRider, setIsRider] = useState(false);

  return (
    <>
      <div>
        <section className="bg-slate-50 mt-[86px] min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 relative">
            <div className="flex flex-col text-left">
              <div className="mb-4">
                <span className="text-sm font-semibold text-slate-600 uppercase tracking-wide">
                  GET PROTECTED TODAY
                </span>
              </div>
              <h1 className="text-5xl font-bold text-slate-900 mb-8">
                Magma Premium Care
              </h1>
              <div className="flex items-center space-x-4 mb-8">
                <div className="bg-white border border-violet-200 rounded-lg p-4 flex items-center space-x-4 shadow-sm">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-users w-8 h-8 text-violet-600"
                    aria-hidden="true"
                  >
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                    <path d="M16 3.128a4 4 0 0 1 0 7.744" />
                    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                    <circle cx={9} cy={7} r={4} />
                  </svg>
                  <div>
                    <span className="block text-lg font-semibold text-violet-600">
                      Coverage:
                    </span>
                    <p className="text-slate-600 font-medium">
                      Self + Spouse + 2 Children
                    </p>
                  </div>
                </div>
              </div>
              <ul className="text-slate-700 text-left space-y-4">
                <li className="flex items-start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                    aria-hidden="true"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                  <span>
                    <strong className="text-gray-800">
                      Unlimited
                    </strong>{" "}
                    – Tele Doctor Consultation (GP)
                  </span>
                </li>
                <li className="flex items-start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                    aria-hidden="true"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                  <span>
                    <strong className="text-gray-800">
                      Unlimited
                    </strong>{" "}
                    – Tele Doctor Consultation (Ayurveda)
                  </span>
                </li>
                <li className="flex items-start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                    aria-hidden="true"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                  <span>
                    <strong className="text-gray-800">
                      Unlimited
                    </strong>{" "}
                    – Tele Doctor Consultation (Homeopathy)
                  </span>
                </li>
                <li className="flex items-start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                    aria-hidden="true"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                  <span>
                    <strong className="text-gray-800">
                      Unlimited
                    </strong>{" "}
                    – Tele Doctor Consultation (18 Specialists)
                  </span>
                </li>
                <li className="flex items-start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                    aria-hidden="true"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                  <span>
                    <strong className="text-gray-800">
                      2 Credits
                    </strong>{" "}
                    – Full Body Checkup (91 parameters)
                  </span>
                </li>
                <li className="flex items-start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                    aria-hidden="true"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                  <span>
                    <strong className="text-gray-800">
                      ₹7500 wallet
                    </strong>{" "}
                    – Diagnostic & Radiology Wallet
                  </span>
                </li>
                <li className="flex items-start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                    aria-hidden="true"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                  <span>
                    <strong className="text-gray-800">
                      2 Credit
                    </strong>{" "}
                    – Virtual Diabetic Consultation
                  </span>
                </li>
                <li className="flex items-start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                    aria-hidden="true"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                  <span>
                    <strong className="text-gray-800">
                       2 Credit or ₹500 Reimbursement
                    </strong>{" "}
                    – In-person General Physician Clinic & Hospital Consultation / My Choice Doctor
                  </span>
                </li>
                <li className="flex items-start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                    aria-hidden="true"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                  <span>
                    <strong className="text-gray-800">
                      ₹2500 wallet
                    </strong>{" "}
                    – Pharmacy Wallet - Prescribed Medicines
                  </span>
                </li>
                <li className="flex items-start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                    aria-hidden="true"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                  <span>
                    <strong className="text-gray-800">
                      1 Credit
                    </strong>{" "}
                    – Dental Checkup & Consultation
                  </span>
                </li>
                <li className="flex items-start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                    aria-hidden="true"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                  <span>
                    <strong className="text-gray-800">
                      2 Credit
                    </strong>{" "}
                    – Mental Wellness
                  </span>
                </li>
                <li className="flex items-start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                    aria-hidden="true"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                  <span>
                    <strong className="text-gray-800">
                      4 Credit
                    </strong>{" "}
                    – Tele Dietician Consultation
                  </span>
                </li>
              </ul>
              <div className="pt-[40px] pb-[20px]"><p className="mb-0 text-[20px] font-bold">Platform Benefits</p></div>
              <ul className="text-slate-700 text-left space-y-4">
                <li className="flex items-start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                    aria-hidden="true"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                  <span>
                    <strong className="text-gray-800">
                      Upto 50% off 
                    </strong>{" "}
                    – on Diagnostic & Radiology
                  </span>
                </li>
                <li className="flex items-start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                    aria-hidden="true"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                  <span>
                    <strong className="text-gray-800">
                      Upto 20% off 
                    </strong>{" "}
                    – on Prescribed Medicines
                  </span>
                </li>
              </ul>
              <div className="pt-[40px] pb-[20px]"><p className="mb-0 text-[20px] font-bold">Value Added Features</p></div>
              <ul className="text-slate-700 text-left space-y-4">
                <li className="flex items-start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                    aria-hidden="true"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                  <span>
                    <strong className="text-gray-800">
                      Applicable
                    </strong>{" "}
                    – Risk Assessment
                  </span>
                </li>
                <li className="flex items-start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                    aria-hidden="true"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                  <span>
                    <strong className="text-gray-800">
                      Applicable
                    </strong>{" "}
                    – Health Reminder
                  </span>
                </li>
                <li className="flex items-start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                    aria-hidden="true"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                  <span>
                    <strong className="text-gray-800">
                      Applicable
                    </strong>{" "}
                    – Recorded Fitness sessions
                  </span>
                </li>
              </ul>
              {/* <div className="pt-[40px] pb-[20px]"><p className="mb-0 text-[20px] font-bold">Rider Benefits</p></div>
              <ul className="text-slate-700 text-left space-y-4">
                <li className="flex items-start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                    aria-hidden="true"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                  <span>
                    <strong className="text-gray-800">
                      ₹5 Lakh
                    </strong>{" "}
                    – Sum Insured
                  </span>
                </li>
                <li className="flex items-start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                    aria-hidden="true"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                  <span>
                    <strong className="text-gray-800">
                      Covered
                    </strong>{" "}
                    – Accidental Death (100% SI Paid on death)
                  </span>
                </li>
                <li className="flex items-start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                    aria-hidden="true"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                  <span>
                    <strong className="text-gray-800">
                      Covered
                    </strong>{" "}
                    – Permanent Total Disability (Upto 100% SI Paid on PTD)
                  </span>
                </li>
                <li className="flex items-start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                    aria-hidden="true"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                  <span>
                    <strong className="text-gray-800">
                      Covered
                    </strong>{" "}
                    – Permanent Partial Disability (Upto 100% SI Paid on PPD)
                  </span>
                </li>
                <li className="flex items-start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                    aria-hidden="true"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                  <span>
                    <strong className="text-gray-800">
                      Covered
                    </strong>{" "}
                    – Temporary Total Disability (Upto ₹5000 per week for maximum 100 weeks)
                  </span>
                </li>
                <li className="flex items-start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                    aria-hidden="true"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                  <span>
                    <strong className="text-gray-800">
                      Covered
                    </strong>{" "}
                    – Accidental Hospitalisation (Upto ₹50000)
                  </span>
                </li>
                <li className="flex items-start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                    aria-hidden="true"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                  <span>
                    <strong className="text-gray-800">
                      Covered
                    </strong>{" "}
                    – Child Education (Upto Rs. ₹5000 per 2 children)
                  </span>
                </li>
                <li className="flex items-start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                    aria-hidden="true"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                  <span>
                    <strong className="text-gray-800">
                      Covered
                    </strong>{" "}
                    – Fracture Bones (Upto ₹25000)
                  </span>
                </li>
                <li className="flex items-start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                    aria-hidden="true"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                  <span>
                    <strong className="text-gray-800">
                      Covered
                    </strong>{" "}
                    – Family Transportaion Allowance (Upto ₹25000)
                  </span>
                </li>

              </ul>
              <div className="pt-[40px] pb-[20px]"><p className="mb-0 text-[20px] font-bold">Hospicash Rider</p></div>
              <ul className="text-slate-700 text-left space-y-4">
                <li className="flex items-start">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-check w-5 h-5 text-slate-500 mr-2 mt-1 flex-shrink-0"
                    aria-hidden="true"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                  <span>
                    Upto 1000 per day of hospitalization for up to 30 days in a year (1 day deductible on hospitalization)
                  </span>
                </li>
              </ul> */}


              <div className="my-8">
                <span className="text-4xl font-bold text-violet-600">₹29,999</span>
                <span className="text-lg text-slate-600 ml-2">(+ GST)</span>
              </div>
              <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
                <button className="bg-violet-600 cursor-pointer hover:bg-slate-600 rounded text-white font-bold py-3 px-8  shadow-lg transition duration-300 ease-in-out" onClick={() => {
                  setPlanCode("MagmaPremiumCare");
                  setOpenPopup(true);
                  setIsRider(true);
                }}>
                  Buy Now
                </button>
                <a href="assets/docs/MagmaPremiumCare.pdf" target="_blank" rel="noopener noreferrer" className="bg-slate-600 text-white border rounded border-slate-600 font-bold py-3 px-8 transition duration-300 ease-in-out hover:bg-transparent hover:!text-[#64748b]">
                  Download Plan Details
                </a>
              </div>
            </div>
            <div className="flex justify-center md:justify-end">
              <div className="w-72 h-72 sm:w-96 sm:h-96 sticky top-[120px]">
                <div className="w-[300px] sm:w-[350px] md:w-[500px] aspect-square animationTransform">
                  <img
                    src="assets/img/all-images/plan3.png"
                    alt="Magma Health Shield"
                    className="w-full h-full object-contain animate-float"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="w-full h-[100px] bg-slate-50"></div>

        <section
          className="relative py-16 px-4 sm:px-6 lg:px-8 overflow-hidden"
          style={{
            background:
              "linear-gradient(85deg, rgb(226, 232, 240) 0%, rgb(241, 245, 249) 50%, rgb(196, 181, 253) 100%)"
          }}
        >
          <div className="max-w-7xl mx-auto px-4 py-6">
            <h2 className="text-3xl md:text-5xl font-bold text-slate-600">
              Your Complete
            </h2>
            <p className="text-xl md:text-2xl lowercase font-extrabold italic text-violet-600 mt-2">
              health and wellness package
            </p>
            <div className="mt-4">
              <svg
                width={300}
                height={20}
                viewBox="0 0 300 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="w-80 h-6 text-violet-600"
              >
                <path
                  d="M0 10 C10 0, 20 20, 30 10 S50 0, 60 10 S80 20, 90 10 S110 0, 120 10 S140 20, 150 10 S170 0, 180 10 S200 20, 210 10 S230 0, 240 10 S260 20, 270 10 S290 0, 300 10"
                  stroke="currentColor"
                  strokeWidth={3}
                  fill="transparent"
                />
              </svg>
            </div>
            <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div className="bg-white rounded-2xl shadow-md p-[20px] border border-gray-200">
                <img
                  src="assets/img/all-images/001.webp"
                  alt="Comprehensive Care Access"
                  className="w-full h-48 object-cover rounded-md mb-4"
                />
                <h3 className="text-[18px] font-bold text-black mb-4">
                  Comprehensive Care Access
                </h3>
                <ul className="list-none space-y-2 text-[15px] text-black">
                  <li>
                    <strong>Unlimited Teleconsultations</strong> – Talk to doctors
                    anytime, any specialty.
                  </li>
                  <li>
                    <strong>Annual Health Check-up</strong> – 1 full check-up per
                    adult, every year.
                  </li>
                  <li>
                    <strong>Wellness Manager</strong> – Personal health concierge,
                    always there for you.
                  </li>
                </ul>
              </div>
              <div className="bg-white rounded-2xl shadow-md p-[20px] border border-gray-200">
                <img
                  src="assets/img/all-images/image-1.png"
                  alt="Advanced Wellness Programs"
                  className="w-full h-48 object-cover rounded-md mb-4"
                />
                <h3 className="text-[18px] font-bold text-black mb-4">
                  Advanced Wellness Programs
                </h3>
                <ul className="list-none space-y-2 text-[15px] text-black">
                  <li>
                    <strong>Mental Wellness Support</strong> – Care for your mind, not
                    just your body.
                  </li>
                  <li>
                    <strong>2 Therapy Sessions + Helpline</strong> – Get expert help
                    and 24/7 support when you need it.
                  </li>
                </ul>
              </div>
              <div className="bg-white rounded-2xl shadow-md p-[20px] border border-gray-200">
                <img
                  src="assets/img/all-images/003.png"
                  alt="Specialist Benefits"
                  className="w-full h-48 object-cover rounded-md mb-4"
                />
                <h3 className="text-[18px] font-bold text-black mb-4">
                  Specialist Benefits
                </h3>
                <ul className="list-none space-y-2 text-[15px] text-black">
                  <li>
                    <strong>Eye &amp; Dental Cover</strong> – 1 eye test + 1 dental
                    consultation per member.
                  </li>
                  <li>
                    <strong>Customized Nutrition Plan</strong> – 2 diet consults +
                    personalized meal tracker.
                  </li>
                </ul>
              </div>
              <div className="bg-white rounded-2xl shadow-md p-[20px] border border-gray-200">
                <img
                  src="assets/img/all-images/004.webp"
                  alt="Medicines & Diagnostics"
                  className="w-full h-48 object-cover rounded-md mb-4"
                />
                <h3 className="text-[18px] font-bold text-black mb-4">
                  Medicines &amp; Diagnostics
                </h3>
                <ul className="list-none space-y-2 text-[15px] text-black">
                  <li>
                    <strong>Diagnostics Discount</strong> – Enjoy up to 40% off on a
                    wide range of lab tests.
                  </li>
                  <li>
                    <strong>Medicine Discount</strong> – Save up to 25% on prescribed
                    medicines and essentials.
                  </li>
                </ul>
              </div>
              <div className="bg-white rounded-2xl shadow-md p-[20px] border border-gray-200">
                <img
                  src="assets/img/all-images/005.jpg"
                  alt="Tools & Extras"
                  className="w-full h-48 object-cover rounded-md mb-4"
                />
                <h3 className="text-[18px] font-bold text-black mb-4">
                  Tools &amp; Extras
                </h3>
                <ul className="list-none space-y-2 text-[15px] text-black">
                  <li>
                    <strong>Health Dashboard &amp; Reminders</strong> – Track progress
                    with smart alerts.
                  </li>
                  <li>
                    <strong>Health Risk Assessment (HRA)</strong> – Annual report to
                    monitor health risks.
                  </li>
                  <li>
                    <strong>Hospitalization Support</strong> – Personal health
                    concierge, always there for you.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </div>

      <BuyPlan
        planCode={planCode}
        tenantId={tenantId}
        showPopUp={openPopup}
        setShowPopUp={setOpenPopup}
        isRider={isRider}
      />
    </>
  );
};

export default MagmaPremiumCarePlan;
